import { useEffect } from 'react';

import toast from '#/components/common/toast';

import EthereumWallet from '#/features/ethereum-wallet/wallet';
import { logException } from '#/features/logging/logging';
import { useAuthActions } from '#/features/auth/auth-context';
import {
  useWalletActions,
  useWalletView,
} from '#/features/wallet/wallet-context';

import { useTranslation } from '#/features/localization/utils';

import { userSignOutTopic } from './auth-topics';

export function useSingOutHandler() {
  const authActions = useAuthActions();
  const walletActions = useWalletActions();
  const walletView = useWalletView();
  const { t } = useTranslation();

  useEffect(() => {
    const handleSignOut = async () => {
      authActions.reset();
      walletActions.reset();
      EthereumWallet.disconnect()
        .then(() => {
          toast.info(t('You have been signed out.'), {
            toastId: 'auth-successfully-signed-out',
          });
        })
        .catch((err) => {
          const message =
            'Unexpected error disconnecting Ethereum' +
            ' wallet during handing Sign Out';
          logException(new Error(message, { cause: err }));
          // Only reload in case of an error
          window.location.reload();
        });
    };

    const unsubscribe = userSignOutTopic.subscribe(handleSignOut);

    return unsubscribe;
  }, [authActions, t, walletActions, walletView]);
}
